import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    topImage: {
        // position: 'absolute',
        width: '472px',
        height: '552.18px',
        // left: '853.39px',
        // top: '214.39px',
        background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
        // border: '2px solid #FFFFFF',
        sizing: 'border-box',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        radius: '15px',
        borderRadius: '25px',
        opacity: 0.9,
        margin: '0 auto 0 auto'
    },
    leftGrid: {
        textAlign: 'left',
    },
    leftGridTypographies:{
        width:"300px",
        //height:"100px",
        // margin: "0 auto",
        // display: "block"
        display: "inline-block"
    },
    rightGrid: {
        //textAlign: 'left'
        //paddingLeft: "100px",
    },
    motivationalTitle: {
        background: 'linear-gradient(to top, rgba(243, 146, 61, 0.7) 35%, transparent 35%)',
        lineHeight: 1.4,
        fontFamily: 'Noto Sans JP, sans-serif',
        fontStyle: 'normal',
        //   fontDisplay: 'swap',
        fontWeight: 500,
        // opacity:0.7,        
    }
    ,
    smallTitle: {
        // background: 'linear-gradient(to top, rgba(243, 146, 61, 0.7) 35%, transparent 35%)',
        // lineHeight: 1.4,
        fontFamily: 'Noto Sans JP, sans-serif',
        // fontStyle: 'normal',
        // //   fontDisplay: 'swap',
        // fontWeight: 500,
    }
    ,
    signupButton: {
        color: 'white',
        background: '#F3923D',
        borderRadius: '32.83px',
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        marginRight: 25,
        fontFamily: 'Noto Sans JP, sans-serif',
    },
    loginButton: {
        color: '#F3923D',
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        background: '#FFFFFF',
        border: '1px solid #F3923D',
        // box-sizing: border-box;
        borderRadius: '32.83px',
        fontFamily: 'Noto Sans JP, sans-serif',
    },
    parentGridContainer: {
        borderRadius: 4,
        //marginTop: '5rem',
        padding: '16px 120px',
        fontFamily: 'Noto Sans JP',
        height: "650px"
    },
    gridContainer: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },

    },
    sliderTab: {
        marginTop: '20rem',
    },
    sponsorDiv: {
        width: '100%',
        align: 'center',
        // sizing: 'border-box',
        // shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        border: '1px solid #333333',
        boxSizing: 'border-box',
        borderRadius: '32.83px',
        margin: '20rem auto 15rem auto',
        // marginTop: '15rem',
        // marginBottom: '30rem',
        // margin: '200px 50px',
        padding: '140px 60px',
    },
    sponsorLogos: {
        height: 120,
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
    },
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
        },
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(3),
        // marginRight: "150px",
    },
    submit: {
        margin: theme.spacing(3, 0, 3),
        color:'white'
    },
    googleButton: {
        marginBottom: theme.spacing(2),
    },
    signupBtn: {
        fontSize: '14px',
        marginRight:'20px',
        fontFamily: 'Noto Sans JP, sans-serif',
        textDecoration: 'none',
        color: "#000000",
    
        "&:hover": {
          // textDecoration: 'none',
          // color: "#000000",
          opacity: 0.7
        }
      },
      buttonsGrid:{
        margin:"20px auto"
      }

}));